<template>
  <div class="LKPublicationsDataCollectionLeft__col--left">
    <div class="LKPublicationsDataCollectionLeft__name">
      {{ data.name }}
    </div>
    <div class="LKPublicationsDataCollectionLeft__bottom">
      <div
        :class="{
          'is-opened': !data.disabled,
          'is-disabled': data.disabled,
        }"
        class="LKPublicationsDataCollectionLeft__status"
        v-text="statusText"
      />

      <div
        class="LKPublicationsDataCollectionLeft__date"
        v-text="dates"
      />

      <!--
      <v-icon
        class="LKPublicationsDataCollectionLeft__btn-outline"
        v-text="'mdi-power-standby'"
      />

      <v-icon
        class="LKPublicationsDataCollectionLeft__btn-outline"
        v-text="'mdi-account-cog-outline'"
      />

      <v-icon
        class="LKPublicationsDataCollectionLeft__btn-outline"
        v-text="'mdi-file-outline'"
      />
      -->
    </div>
  </div>
</template>


<script>
import { dateFormatter } from '@/helpers/dateFormatter'


const DATE_FORMAT = 'D MMMM YYYY, HH:mm'

export default {
  name: 'LKPublicationsDataCollectionLeft',
  props: {
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'disabled' in prop
        && 'start_at' in prop
        && 'end_at' in prop
      ),
    },
  },
  computed: {
    dates() {
      const { data } = this

      return [
        dateFormatter(data.start_at, DATE_FORMAT),
        dateFormatter(data.end_at, DATE_FORMAT),
      ].join(' - ')
    },
    statusText() {
      const { disabled } = this.data
      return disabled ? 'Закрыт' : 'Открыт'
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsDataCollectionLeft {
  position: relative;
  display: flex;
  padding: 18px 22px 25px 22px;
  background-color: $webflow-color-blue-shadow;

  &__name {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 600;
  }

  &__status {
    padding: 6px 11px;
    color: $color-white;
    border-radius: 2px;

    &.is-done {
      background-color: $webflow-color-grey;
    }

    &.is-not-done {
      background-color: $webflow-color-red;
    }

    &.is-opened {
      white-space: nowrap;
      background-color: $webflow-color-green;
    }

    &.is-disabled {
      background-color: $webflow-color-blue;
    }
  }

  &__bottom {
    display: flex;
  }

  &__date,
  &__btn-outline {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    margin-left: 12px;
    border: 1px solid $webflow-color-blue-light;
    border-radius: 2px;
  }

  &__date {
    padding: 6px 11px;
    font-size: 12px;
    color: $webflow-color-blue-dark-2;
    text-align: center;
    white-space: nowrap;
  }
}
</style>
